import Vue from 'vue'

import {
  ButtonPlugin,
  FormCheckboxPlugin,
  FormDatepickerPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormPlugin,
  FormRadioPlugin,
  FormSelectPlugin,
  FormTextareaPlugin,
  FormTimepickerPlugin,
  IconsPlugin,
  LayoutPlugin,
  LinkPlugin,
  ModalPlugin,
  PaginationPlugin,
  ProgressPlugin,
  TablePlugin
} from 'bootstrap-vue'
// ToastPlugin,
// InputGroupPlugin,
// DropdownPlugin,
// BadgePlugin,

Vue.use(ButtonPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormDatepickerPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormPlugin)
Vue.use(FormRadioPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(FormTimepickerPlugin)
Vue.use(IconsPlugin)
Vue.use(LayoutPlugin)
Vue.use(LinkPlugin)
Vue.use(ModalPlugin)
Vue.use(PaginationPlugin)
Vue.use(ProgressPlugin)
Vue.use(TablePlugin)
// Vue.use(ToastPlugin)
// Vue.use(InputGroupPlugin)
// Vue.use(DropdownPlugin)
// Vue.use(BadgePlugin)
